import React from 'react';
import { useTranslation } from 'react-i18next';

import AccountRegistrationForm from './components/AccountRegistrationForm';
import styles from './components/registration.scss';

const NewAccountRegistration = () => {
  const { t } = useTranslation();
  return (
    <div>
      <div className="l-title-wrap">
        <h1 className="m-title-main">{t("features.Registrations.NewAccountRegistration.Account_Registration")}</h1>
        <p className={styles.lead}>
          {t("features.Registrations.NewAccountRegistration.Those_who_want_to_start_a_trial_first_those_who_want_to_start_using_immediately")}<br />{t("features.Registrations.NewAccountRegistration.Please_register_for_a_free_account_with_all_the_features_available")}
        </p>
        <p className={styles.notes}>
          ※ {t("features.Registrations.NewAccountRegistration.Campaign_details_will_be_sent_to_you_by_email_after_your_account_is_issued")}
        </p>
      </div>
      <div className={styles.columnWrap}>
        <div className={styles.columnFlow}>
          <h2 className="m-title-sub u-ta-c u-pt0">{t("features.Registrations.NewAccountRegistration.Free_account_registration_process")}</h2>
          <div className={styles.flowWrap}>
            <dl className={styles.flowItem}>
              <dt className={styles.flowHead}>1. {t("features.Registrations.NewAccountRegistration.Account_Registration")}</dt>
              <dd className={styles.flowBody}>{t("features.Registrations.NewAccountRegistration.After_registration_your_login_information_will_be_sent_to_your_email")}</dd>
            </dl>
            <dl className={styles.flowItem}>
              <dt className={styles.flowHead}>2. {t("features.Registrations.NewAccountRegistration.Initial_Setting")}</dt>
              <dd className={styles.flowBody}>{t("features.Registrations.NewAccountRegistration.Enter_the_required_information")}</dd>
            </dl>
            <dl className={styles.flowItem}>
              <dt className={styles.flowHead}>3. {t("features.Registrations.NewAccountRegistration.30_days_of_use")}</dt>
              <dd className={styles.flowBody}>{t("features.Registrations.NewAccountRegistration.All_features_are_available_for_30_days")}</dd>
            </dl>
            <dl className={styles.flowItem}>
              <dt className={styles.flowHead}>4. {t("features.Registrations.NewAccountRegistration.After_the_30_day_period")}</dt>
              <dd className={styles.flowBody}>
                {t("features.Registrations.NewAccountRegistration.After_30_days_your_account_will_be_automatically_changed_to_a_free_plan_Please_apply_for_a_paid_plan_if_you_want_to_continue_using_all_the_features")}
              </dd>
            </dl>
          </div>
        </div>
        <div className={styles.columnForm}>
          <AccountRegistrationForm />
        </div>
      </div>
    </div>
  );
};

export default NewAccountRegistration;
